import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbarpro from './sidebar';
import API_BASE_URL from "../../../config";
import {
  Container,
  Card,
  Table,
  Button,
  Image,
  Modal,
} from 'react-bootstrap';
import { EyeFill, CheckCircleFill } from 'react-bootstrap-icons';

const Notification = () => {
  const [vendors, setVendors] = useState([]);
  const [acceptedVendors, setAcceptedVendors] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/vendor`)
      .then(res => {
        setVendors(res.data);
        console.log("Fetched vendors:", res.data);
      })
      .catch(err => {
        console.error("Error fetching vendors:", err);
      });
  }, []);

  const handleAccept = (userData) => {
    axios.post(`${API_BASE_URL}/postdatabase/${userData._id}`, {
      Business_Name: userData.Business_Name,
      Owner_name: userData.Owner_name,
      Email_address: userData.Email_address,
      Phone_number: userData.Phone_number,
      Business_address: userData.Business_address,
      Category: userData.Category,
      Sub_Category: userData.Sub_Category,
      Tax_ID: userData.Tax_ID,
      ID_Type: userData.ID_Type,
      Password: userData.Password, // already hashed
      ProductUrls: userData.ProductUrls || [],
      Profile_Image: userData.Profile_Image || "",
      Latitude: userData.Latitude,
      Longitude: userData.Longitude,
      Account_Number: userData.Account_Number || "",
      IFSC_Code: userData.IFSC_Code || "",
      Charge_Per_Hour_or_Day: userData.Charge_Per_Hour_or_Day || "",
      Charge_Type: userData.Charge_Type || "",
      registrationDate: userData.registrationDate,
      description: userData.description
    })
      .then(res => {
        console.log("User posted successfully:", res.data);
        alert("User accepted and posted successfully!");
        setAcceptedVendors(prev => [...prev, userData._id]);
      })
      .catch(err => {
        console.error("Error posting user:", err);
        alert("Error posting user data.");
      });
  };

  const handleShowDetails = (vendor) => {
    setSelectedVendor(vendor);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedVendor(null);
  };

  return (
    <div className="page-container">
      <Navbarpro />

      <Container className="mt-4">
        <h2 className="mb-4">Notification Panel</h2>

        <Card className="mb-4 shadow-sm">
          <Card.Body>
            <Card.Title>Pending Approvals</Card.Title>
            <Table striped bordered hover responsive className="mt-3">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Service Type</th>
                  <th>Registration Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {vendors.map((user) => (
                  <tr key={user._id}>
                    <td>{user.Owner_name}</td>
                    <td>{user.Category}</td>
                    <td>{new Date(user.registrationDate).toLocaleDateString()}</td>
                    <td>
                      {acceptedVendors.includes(user._id) ? (
                        <CheckCircleFill color="green" size={24} />
                      ) : (
                        <>
                          <Button
                            variant="success"
                            size="sm"
                            className="me-2"
                            onClick={() => handleAccept(user)}
                          >
                            Approve
                          </Button>
                          <Button variant="danger" size="sm" className="me-2">
                            Reject
                          </Button>
                        </>
                      )}
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => handleShowDetails(user)}
                      >
                        <EyeFill />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Container>

      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Vendor Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedVendor && (
            <div>
              <p><strong>Business Name:</strong> {selectedVendor.Business_Name}</p>
              <p><strong>Owner Name:</strong> {selectedVendor.Owner_name}</p>
              <p><strong>Email:</strong> {selectedVendor.Email_address}</p>
              <p><strong>Phone:</strong> {selectedVendor.Phone_number}</p>
              <p><strong>Address:</strong> {selectedVendor.Business_address}</p>
              <p><strong>Category:</strong> {selectedVendor.Category}</p>
              <p><strong>Sub-Category:</strong> {selectedVendor.Sub_Category.join(', ')}</p>
              <p><strong>Tax ID:</strong> {selectedVendor.Tax_ID}</p>
              <p><strong>ID Type:</strong> {selectedVendor.ID_Type}</p>
              <p><strong>Latitude:</strong> {selectedVendor.Latitude}</p>
              <p><strong>Longitude:</strong> {selectedVendor.Longitude}</p>
              <p><strong>Registration Date:</strong> {new Date(selectedVendor.registrationDate).toLocaleString()}</p>
              {selectedVendor.ProductUrls && selectedVendor.ProductUrls.length > 0 && (
                <div className="mt-3">
                  <strong>Product Images:</strong>
                  {selectedVendor.ProductUrls.map((url, idx) => (
                    <Image key={idx} src={url} alt={`Product ${idx + 1}`} fluid className="mt-2" />
                  ))}
                </div>
              )}
              {selectedVendor.Profile_Image && (
                <div className="mt-3">
                  <strong>Profile Image:</strong>
                  <Image src={selectedVendor.Profile_Image} alt="Profile" fluid className="mt-2" />
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Notification;
